export default function makeNameFromPersona({persona, language = "en", isLastNameFirst = true}) {
  if (!persona || (!persona.engFirstName && !persona.firstName && !persona.engLastName && !persona.lastName)) return "";

  return isLastNameFirst
    ? `${language === "en" ? persona.engLastName || "" : persona.lastName || ""} ${
        language === "en" ? persona.engFirstName || "" : persona.firstName || ""
      }`
    : `${language === "en" ? persona.engFirstName || "" : persona.firstName || ""} ${
        language === "en" ? persona.engLastName || "" : persona.lastName || ""
      }`;
}
